interface Props {
    className?: string;
    children?: React.ReactNode;
}

export const PageTitle = ({ children, className }: Props): React.ReactElement<any, any> | null => {
    return <h1 className={`d-flex mb-0 ${className ? className : ''}`}>{children}</h1>;
};
